export const formatterPostosAtendimentoBackToFront = postoAtendimentoApi => {
  return {
    nomePosto: postoAtendimentoApi?.nome,
    endereco: postoAtendimentoApi?.endereco,
    telefone: postoAtendimentoApi?.telefone,
    diasHorariosAtendimentos: postoAtendimentoApi?.diasHorariosAtendimentos,
    solicitacaoIds: postoAtendimentoApi?.postoSolicitacoes?.map(s => s?.solicitacaoId),
  };
};

export const formatterPostosAtendimentoFrontToBackCreate = dadosInputs => {
  return {
    nome: dadosInputs?.nomePosto,
    endereco: dadosInputs?.endereco,
    telefone: dadosInputs?.telefone,
    diasHorariosAtendimentos: dadosInputs?.diasHorariosAtendimentos,
    postoSolicitacoes: dadosInputs?.solicitacaoIds.map(s => ({ solicitacaoId: s })),
    id: 0,
  };
};

export const formatterPostosAtendimentoFrontToBackUpdate = (dadosInputs, id) => {
  return {
    nome: dadosInputs?.nomePosto,
    endereco: dadosInputs?.endereco,
    telefone: dadosInputs?.telefone,
    diasHorariosAtendimentos: dadosInputs?.diasHorariosAtendimentos,
    postoSolicitacoes: dadosInputs?.solicitacaoIds.map(s => ({ solicitacaoId: s })),
    id: id,
  };
};

export const formatterPostosAtendimentoNull = () => {
  return {
    nomePosto: '',
    endereco: '',
    telefone: '',
    diasHorariosAtendimentos: '',
    solicitacaoIds: [],
  };
};
